import React, { Component } from "react";
import T from "prop-types";
import { onSuccess } from "LIB/submission";
import { Footer, Body } from "MODULES/shared/components/Modal";
import Errors from "./Errors";

export function Cancel({ close, editable }) {
  return (
    <button type="button" className="btn btn-default" onClick={close}>
      {editable ? "Cancel" : "Close"}
    </button>
  );
}

Cancel.propTypes = {
  close: T.func.isRequired,
  editable: T.bool
};

export function Submit({
  disabled,
  submitting,
  submitTimeout,
  editable,
  onClick,
  text = "Save",
  submittingText = "Saving"
}) {
  return (
    editable && (
      <button
        onClick={onClick}
        disabled={disabled || submitting || submitTimeout}
        type="submit"
        className="btn btn-primary"
      >
        {submitting && <i className="fa fa-cog fa-spin fa-fw fa-lg" />}
        {submitting ? ` ${submittingText}` : text}
      </button>
    )
  );
}

Submit.propTypes = {
  submitting: T.bool,
  disabled: T.bool,
  editable: T.bool
};

export function AdditionalButtons({ children }) {
  return children;
}

export function DefaultControls({
  disabled,
  editable,
  errorMessages,
  footer,
  submitting,
  submitFailed,
  submitSucceeded,
  submitTimeout,
  close,
  modal,
  buttonText
}) {
  let errors;
  if (submitTimeout) {
    errors = [
      "The request timed out. Please refresh page and check to see if expected records were updated before resubmitting."
    ];
  } else {
    errors = errorMessages;
  }

  return (
    <Footer style={modal ? {} : { paddingRight: 0 }}>
      {(submitFailed || submitTimeout) && <Errors errors={errors} />}
      <Cancel close={close} editable={editable} />
      {footer}
      <Submit
        disabled={disabled}
        submitting={submitting}
        submitSucceeded={submitSucceeded}
        submitTimeout={submitTimeout}
        editable={editable}
        text={buttonText}
      />
    </Footer>
  );
}

DefaultControls.propTypes = {
  close: T.func.isRequired,
  errorMessages: T.arrayOf(T.string),
  editable: T.bool,
  footer: T.node,
  disabled: T.bool,
  submitting: T.bool,
  submitFailed: T.bool,
  submitSucceeded: T.bool,
  submitTimeout: T.bool,
  modal: T.bool
};

export default class Form extends Component {
  static propTypes = {
    children: T.oneOfType([T.element, T.arrayOf(T.element)]),
    close: T.func.isRequired,
    handleSubmit: T.func.isRequired,
    modal: T.bool
  };

  static Body = Body;
  static Footer = Footer;
  static Cancel = Cancel;
  static Submit = Submit;
  static DefaultControls = DefaultControls;
  static AdditionalButtons = AdditionalButtons;

  state = {
    submitTimeout: false
  };

  handleSubmitError = error => {
    if (error.code === "TIMEOUT") {
      this.setState({ submitTimeout: true });
    }
  };

  render() {
    const { children, close, handleSubmit, modal } = this.props;
    const { submitTimeout } = this.state;
    const submit = onSuccess(
      handleSubmit,
      close,
      this.props,
      this.handleSubmitError
    );
    const body = children[0] || children;
    const footer = children[1] || null;

    return (
      <form onSubmit={submit}>
        {modal ? (
          <Body>{body.props.children}</Body>
        ) : (
          <div>{body.props.children}</div>
        )}
        {(footer && footer.type !== AdditionalButtons && footer) || (
          <DefaultControls
            {...this.props}
            submitTimeout={submitTimeout}
            footer={footer}
          />
        )}
      </form>
    );
  }
}

Form.defaultProps = {
  editable: true,
  modal: true
};



// WEBPACK FOOTER //
// ./app/modules/shared/components/Forms/AppForm.jsx